<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {};
  },
  created() {
    
  },
  mounted() {
    
  },
  methods: {
    
  },
}
</script>

<style lang="less">
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Microsoft YaHei';
  font-weight: 400;
}
img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
}

#app {
  width: 100vw;
  height: 100vh;
  overflow-y: hidden;
  overflow-x: hidden;
  user-select: none;
}
</style>
